import { Controller } from 'stimulus';
import formatPrice from '@/helpers/formatPrice';

class ProductController extends Controller {
  connect() {
    this.hasPallets = this.data.get('hasPallets') === 'true';
    this.priceSchemes = Object.values(JSON.parse(this.data.get('priceSchemes')));
    this.amountInStock = parseInt(this.data.get('amountInStock'), 10);

    this.priceSchemes.reverse();

    if (this.hasPallets) {
      this.updatePriceForPallets();
    } else {
      this.updatePrice();
    }
  }

  onQuantityChange() {
    if (this.hasPallets) {
      this.updatePriceForPallets();

      return;
    }

    this.updatePrice();
  }

  onPalletTypeChange() {
    this.quantityTarget.value = 1;

    if (this.hasPallets) {
      this.updatePriceForPallets();

      return;
    }

    this.updatePrice();
  }

  updatePrice() {
    if (!this.hasPriceTarget || !this.hasQuantityTarget) return;

    const quantity = parseInt(this.quantityTarget.value, 10);
    const priceScheme = this.priceSchemes.find((scheme) => quantity >= scheme.minimum_quantity);

    if (typeof priceScheme === 'undefined') return;

    const { price, oldPrice } = priceScheme;

    if (oldPrice && this.hasOldPriceTarget) {
      this.oldPriceTarget.innerHTML = formatPrice(oldPrice);
    }

    this.priceTarget.innerHTML = formatPrice(price);
    this.totalPriceTarget.innerHTML = formatPrice(price * quantity);
    this.totalQuantityTarget.innerHTML = quantity;
  }

  updatePriceForPallets() {
    if (!this.hasPriceTarget || !this.hasQuantityTarget || !this.hasPalletTypeTarget) return;

    const quantity = parseInt(this.quantityTarget.value, 10);
    const palletType = this.palletTypeTarget.value;
    const priceScheme = this.priceSchemes.find((scheme) => palletType === scheme.pallet_type);

    if (typeof priceScheme === 'undefined') return;

    const { price, old_price: oldPrice, pallet_quantity: palletQuantity } = priceScheme;

    if (oldPrice && this.hasOldPriceTarget) {
      this.oldPriceTarget.innerHTML = formatPrice(oldPrice);
    }

    this.priceTarget.innerHTML = formatPrice(price);
    this.totalPriceTarget.innerHTML = formatPrice(price * (quantity * palletQuantity));
    this.totalQuantityTarget.innerHTML = quantity * palletQuantity;

    this.updateMaximumQuantity(palletQuantity);
  }

  updateMaximumQuantity(palletQuantity) {
    this.quantityTarget.max = Math.floor(this.amountInStock / palletQuantity);
  }
}

ProductController.targets = [
  'price',
  'oldPrice',
  'quantity',
  'palletType',
  'totalPrice',
  'totalQuantity',
];

export default ProductController;
